import { Box } from '@wishket/design-system';
import { twJoin } from 'tailwind-merge';

import { Skeleton } from '@/shared/Components';

const PersonalDataHeaderSkeleton = () => {
  return (
    <Box
      className={twJoin(
        'flex flex-col items-center gap-6 px-5',
        'tablet:flex-row tablet:justify-between desktop:px-8'
      )}
    >
      <Box className="flex h-[56px] w-full items-center gap-6 desktop:h-[64px]">
        <Skeleton className="size-[48px] shrink-0 rounded-3xl desktop:size-[56px]" />
        <Skeleton className="h-[52px] w-full rounded-xl desktop:h-[26px]" />
      </Box>
      <Skeleton className="h-[52px] w-full rounded-xl desktop:h-[26px]" />
    </Box>
  );
};

export default PersonalDataHeaderSkeleton;
